import React, { useEffect, useState } from "react";
import { getUsersCount, getUsersList, getUsersListV2 } from "../employees/helper/api";
import { isAuthenticated } from "../../auth";
import { convertTo24Hour, doTimeRangesOverlap, findAvailableSlots, formatDateTime, getUserRole, startLoader, stopLoader } from "../../lib/utils";
import FlatPicker from 'flatpickr';
import { saveAppointmentSlots } from "../appointment/helper/api";
import GymFilter from "../../components/gym-filter";
import SearchFilter from "../../components/search-filter";
// import config from "../../config";
import client from "../../clients";
import Toast from "../../lib/toast";
import '../appointment/style.scss';
import { createGroupClass, getAllGroupClass, getGroupClassCount, updateGroupClass } from "../group-class/helper/api";
import _ from "lodash";

let flatpickr;

export default function TrainerSlotBooking(props){

  const [currentElementId, setCurrentElementId] = useState("");
  var [pageNo,setPageNo] = useState({user:1,groupclass:1});
  const [modalType,setModalType] = useState("create-appointment");
  const [selectedDay,setSelectedDay] = useState('Monday');
  const [isButtonLock,setButtonLock] = useState(false);
  const [selectedGroupClass,setSelectedGroupClass] = useState('');
  const [startGroupClassListLazyLoader,setStartGroupClassListLazyLoader] = useState(false);
  const [selectedCopydays,setSelectedCopydays] = useState([])
  const [appointmentSlots,setAppointmentSlots] = useState({
    sun:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    },
    mon:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    },
    tue:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    },
    wed:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    },
    thu:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    },
    fri:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    },
    sat:{
      copyFrom:'',
      slot_duration:15,
      slots:[],
      slot_limit: 1
    }
  })
  const pageSize = {
    user:20,
    groupclass:20
  };
  var [pageCount,setPageCount] = useState({
    user:1,
    groupclass:1
  })
  var [total,setTotal] = useState({
    user:0,
    groupclass:0
  })
  const [time, setTime] = useState({
    hr: ["00","01","02","03","04","05","06","07","08","09","10","11","12"],
    min: ["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60"]
  });

  const [tempSelectTime,setTempSelectTime]=useState({
    hr:'',
    min:''
  })

  const [isCustomDuration, setCustomDuration] = useState(false);

  const [startTime, setStartTime] = useState({
    hr: "",
    min: "",
    period: "AM" 
  }) 

  const [endTime, setEndTime] = useState({
    hr: "",
    min: "",
    period: "AM" 
  })

  const [globalBookingLimit, setGlobalBookingLimit] = useState(1);
  const [addedBookingLimit, setAddedBookingLimit] = useState(1);


  const [slotIndex,setSlotIndex]=useState(0);
  

  const [timeSelectorType, setTimeSelectorTime] = useState("")


  const [selectedUser, setSelectUser] = useState();
  const [userSearchKey,setUserSearchKey] = useState('');
  const [isUserSpinnerLoader,setUserSpinnerLoader]=useState(false);
  const [bookingType, setBookingType] = useState("appointment");
  const [groupClassName, setGroupClassName] = useState("");
  //"Sunrise Yoga", "Power Yoga", "Stretch & Relax", "Mindful Movement", "Core & Calm"
  const [groupClasses, setGroupClasses] = useState([]);
  const [manageGroupClass, setManageGroupClass] = useState(false); 
  const [isGroupClassInstructor, setGroupClassInstructor] = useState(false);

  const [usersList, setUsersList] = useState([
    // {
    //   name: "Bablu Das",
    //   designation: ["Trainer", "Programmer", "Nutritionist"],
    // },
    // {
    //   name: "Amit Sharma",
    //   designation: ["Trainer", "Yoga Instructor"],
    // },
    // {
    //   name: "Priya Patel",
    //   designation: ["Nutritionist", "Dietitian"],
    // },
    // {
    //   name: "Rohan Gupta",
    //   designation: ["Trainer", "CrossFit Coach"],
    // },
    // {
    //   name: "Anjali Mehta",
    //   designation: ["Dance Instructor", "Zumba Coach"],
    // },
    // {
    //   name: "Vikas Singh",
    //   designation: ["Martial Arts Instructor", "Kickboxing"],
    // },
    // {
    //   name: "Sneha Kapoor",
    //   designation: ["Yoga Instructor", "Meditation Coach"],
    // },
    // {
    //   name: "Rahul Verma",
    //   designation: ["Personal Trainer", "Strength Coach"],
    // },
    // {
    //   name: "Kavita Joshi",
    //   designation: ["Dietitian", "Health Coach"],
    // },
    // {
    //   name: "Suresh Nair",
    //   designation: ["CrossFit Coach", "HIIT Trainer"],
    // },
    // {
    //   name: "Pooja Iyer",
    //   designation: ["Dance Instructor", "Hip-Hop Trainer"],
    // },
    // {
    //   name: "Arjun Khanna",
    //   designation: ["Martial Arts Instructor", "Karate Coach"],
    // },
    // {
    //   name: "Megha Reddy",
    //   designation: ["Pilates Instructor", "Flexibility Coach"],
    // },
    // {
    //   name: "Tarun Malhotra",
    //   designation: ["Personal Trainer", "Strength Coach"],
    // },
    // {
    //   name: "Simran Kaur",
    //   designation: ["Nutritionist", "Wellness Coach"],
    // },
  ]);

  const [selectedDate,setSelectedDate] = useState('');
  const [selectedBranch,setSelectedBranch] = useState('');
  const [deletedAppointmentSlots,setDeletedAppointmentSlots] = useState([]);

  const {user, token} = isAuthenticated();




  //class api
  const SaveGroupClass = async event =>{
    try{
      await startLoader();
      const payload = {
        branchId:selectedBranch._id,
        gymId:selectedBranch.gymId,
        userId:selectedUser._id,
        createdAt:new Date(),
        weekdays:{...appointmentSlots},
      }

      const response = selectedGroupClass?await updateGroupClass(user._id,token,selectedGroupClass.groupClassId,payload):await createGroupClass(user._id,token,payload);
      if(response.error){
         new Toast({
          duration:3000,
          message:response.error,
          type:"error"
        })
      }else{
        new Toast({
          duration:3000,
          message:"Class creaed successfully",
          type:"success"
        })
        props.toggleCreateAppointment();
      }
      await stopLoader();
    }catch(error){
      await stopLoader();
    }
  }

  const GetGroupClassParams = () =>{
    const params = {
      pageNo:pageNo.groupclass,
      pageSize:pageSize.groupclass,
    }
    params.activationStatus = "activate";
    if (selectedBranch) params.gymIDs = [selectedBranch.gym[0]._id];
    if (selectedBranch) params.branchIDs = selectedBranch._id;
    if (groupClassName) params.q = groupClassName;
  }

  const GetAllGroupClass = async (isReload) =>{
    try{
      const params = GetGroupClassParams();

      const response = await getAllGroupClass(user._id,token,params);
      if(!response.error){
        //const findGrpClass = await 
        setGroupClasses(isReload?response:[...groupClasses,...response]);
      }
    }catch(error){
    
    }
  }

  const GetGroupClassCount = async () =>{
    try{
      const params = GetGroupClassParams();
      const response = await getGroupClassCount(user._id,token,params);
      if(!response.error){
        pageNo.groupclass = 1;
       setPageNo(pageNo)
       total.groupclass = response.COUNT
       setTotal(total);
       pageCount.groupclass = Math.ceil(response.COUNT / pageSize.groupclass)
       setPageCount(pageCount);
      }
    }catch(error){
    
    }
  }
  //end of class api


  const getBranch = branch =>{
    setSelectedBranch(branch);
  }

  const SaveAppointmentSlots = async event =>{
    try{
      await startLoader();
      setButtonLock(true);
      

      const payload = {
        branchId:selectedBranch._id,
        gymId:selectedBranch.gymId,
        userId:selectedUser._id,
        slotAssignDate:selectedDate,
        slotAssignDateString:formatDateTime(selectedDate),
        createdAt:new Date(),
        weekdays:{...appointmentSlots},
        deletedAppointmentSlots
      };

      const response = await saveAppointmentSlots(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Something went wrong"
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Appointment slots saved successfully"
        })
        props.toggleCreateAppointment();
        if(props.refreshCalenderSlot) props.refreshCalenderSlot(response);
      }
      await stopLoader();
    }catch(error){
      await stopLoader();
    }
    setButtonLock(false);
  }

  const resetCopyFromSelection = event =>{
    let copyDays = [...selectedCopydays];
    setAppointmentSlots(oldstate=>{
      copyDays.forEach(day=>{
        oldstate[day.toLowerCase().substring(0,3)].slot_duration=15;
        oldstate[day.toLowerCase().substring(0,3)].slots=[];
        copyDays.splice(copyDays.indexOf(day),1);
      })
      return {...oldstate};
    })
    setSelectedCopydays(copyDays);
  }

  const handleCopydays = dayName =>{
    const selectedDayKeyName = selectedDay?selectedDay.toLowerCase().substring(0,3):"";
    const copySelectedCopyDays = [...selectedCopydays];
    const findSelectedDaysIndex = copySelectedCopyDays.indexOf(dayName);
    const dayKeyName = dayName.toLowerCase().substring(0,3);

    if(findSelectedDaysIndex == -1){
      copySelectedCopyDays.push(dayName);
      setAppointmentSlots(oldstate=>{
        oldstate[dayKeyName].slots=appointmentSlots[selectedDayKeyName].slots;
        oldstate[dayKeyName].slot_duration = appointmentSlots[selectedDayKeyName].slot_duration;  
        return {...oldstate};
      })
    }else{

      const slots = appointmentSlots[dayKeyName].slots;
      let deletedAvlSlots = [...deletedAppointmentSlots];
      for(const slot of slots){
        const slotRange = slot.slotRange;
        const availableSlots = slot.availableSlots;
      
        for(const availableSlot of availableSlots){
          let data = {
            slotRange,
            slotTime:{
              startTime:availableSlot.startTime,
              endTime:availableSlot.endTime
            },
            weekDayName:dayName
          }

          deletedAvlSlots.push(data);
        }
      }

      setDeletedAppointmentSlots(deletedAvlSlots);

      setAppointmentSlots(oldstate=>{
        oldstate[dayKeyName].slots=[];
        oldstate[dayKeyName].slot_duration = 15;  
        return {...oldstate};
      })
      copySelectedCopyDays.splice(findSelectedDaysIndex,1)
    }

    setSelectedCopydays(copySelectedCopyDays);
  }

  const handleManageSlotBookingLimit = (dayKeys, slotIndex, availableSlotIndex, action) => {
    const selectedDays = Array.isArray(dayKeys)
      ? dayKeys.map(d => d.toLowerCase().substring(0, 3))
      : [dayKeys.toLowerCase().substring(0, 3)];

    setAppointmentSlots(prev => {
      const updated = { ...prev };

      selectedDays.forEach(day => {
        const dayData = updated[day];
        if (!dayData || !Array.isArray(dayData.slots) || !dayData.slots[slotIndex]) return;

        const daySlots = [...dayData.slots];
        const currentSlot = { ...daySlots[slotIndex] };

        const available = Array.isArray(currentSlot.availableSlots)
          ? [...currentSlot.availableSlots]
          : [];

        const currentSlotData = available[availableSlotIndex] || {};

        const currentLimit = Number.isFinite(parseInt(currentSlotData.slot_limit))
          ? parseInt(currentSlotData.slot_limit)
          : 0;

        let newLimit = currentLimit;
        if (action === "add") {
          newLimit = currentLimit + 1;
        } else if (action === "remove") {
          newLimit = Math.max(0, currentLimit - 1);
        }

        available[availableSlotIndex] = {
          ...currentSlotData,
          slot_limit: newLimit,
        };

        currentSlot.availableSlots = available;
        daySlots[slotIndex] = currentSlot;

        updated[day] = {
          ...dayData,
          slots: daySlots,
        };
      });

      return updated;
    });
  };



  const removeTimeSlot = index =>{
    const copySelectedDays = [...selectedCopydays].map(d=>d.toLowerCase().substring(0,3));
    const dayName =  selectedDay.toLowerCase().substring(0,3);

    const list_weekdays = [...selectedCopydays];
    list_weekdays.push(selectedDay);

    let deletedAvlSlots = [...deletedAppointmentSlots];

    for(const weekday of list_weekdays){
      let data = {
        slotRange:appointmentSlots[dayName].slots[slotIndex].slotRange,
        slotTime:{
          startTime:appointmentSlots[dayName].slots[slotIndex].availableSlots[index].startTime,
          endTime:appointmentSlots[dayName].slots[slotIndex].availableSlots[index].endTime
        },
        weekDayName:weekday
      }

      deletedAvlSlots.push(data);
    }

    setDeletedAppointmentSlots(deletedAvlSlots)



    setAppointmentSlots(oldstate=>{
      oldstate[dayName].slots[slotIndex].availableSlots.splice(index,1); 
      copySelectedDays.forEach(name=>{
        oldstate[name].slots=oldstate[dayName].slots;
      });
      return {...oldstate};
    })
  }

  const addNewSlot = event =>{
    event.preventDefault();
    let newStartTime = {...startTime};
    let newEndTime = {...endTime};

    if(!newStartTime.hr && !newStartTime.min && !newEndTime.hr && !newEndTime.min){
      new Toast({
        type:"warning",
        duration:3000,
        message:"Start and end time should be selected"
      })
      return;
    }

    let new_start_time_hour_24_format =  convertTo24Hour(`${newStartTime.hr}:${newStartTime.min!=""?newStartTime.min:0} ${newStartTime.period}`);
    let new_end_time_hour_24_format =  convertTo24Hour(`${newEndTime.hr}:${newEndTime.min!=""?newEndTime.min:0} ${newEndTime.period}`);
    
    const new_start_time = {
      hr:parseInt(new_start_time_hour_24_format.split(":")[0]),
      min:parseInt(new_start_time_hour_24_format.split(":")[1])
    }

    const new_end_time = {
      hr:parseInt(new_end_time_hour_24_format.split(":")[0]),
      min:parseInt(new_end_time_hour_24_format.split(":")[1])
    }


    let filteredSlots = appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots.filter(data=>{
      
      let start_time_hour_24_format =  convertTo24Hour(`${data.slotRange.startTime.hr}:${data.slotRange.startTime.min} ${data.slotRange.startTime.period}`);
      let end_time_hour_24_format =  convertTo24Hour(`${data.slotRange.endTime.hr}:${data.slotRange.endTime.min} ${data.slotRange.endTime.period}`);

      
      const start_time = {
        hr:parseInt(start_time_hour_24_format.split(":")[0]),
        min:parseInt(start_time_hour_24_format.split(":")[1])
      }

      const end_time = {
        hr:parseInt(end_time_hour_24_format.split(":")[0]),
        min:parseInt(end_time_hour_24_format.split(":")[1])
      }
      

      return doTimeRangesOverlap(new_start_time,new_end_time,start_time,end_time);
      
    })

    if(filteredSlots.length){
      new Toast({
        type:"warning",
        duration:3000,
        message:"Time range already exists"
      })
      return;
    }

    if(!(newStartTime.hr!="" && newStartTime.min!="" && newEndTime.hr!="" && newEndTime.min != "")){
      new Toast({
        type:"warning",
        duration:3000,
        message:"start and end time should be selected"
      })
      return;
    }

    let item = {
      slotRange:{
        startTime:{...newStartTime},
        endTime:{...newEndTime}
      },
      availableSlots:[]
    }

    let slots = findAvailableSlots(new_start_time,new_end_time,parseInt(appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration)-5).map(data=>({lock:false,startTime:{...data.start},endTime:{...data.end}, slot_limit: addedBookingLimit == null ? 1: addedBookingLimit}));

    item.availableSlots = slots;
    setAppointmentSlots(oldstate=>{
      oldstate[selectedDay.toLowerCase().substring(0,3)].slots.push(item);
      return {...oldstate};
    })

    setStartTime({
      ...startTime,
      hr:"",
      min:"",
      period:"AM"
    })
    setEndTime({
      ...endTime,
      hr:"",
      min:"",
      period:"AM"
    })
  }

  const removeSlot = index => event =>{

    let total_weekdays = [...selectedCopydays];
    total_weekdays.push(selectedDay);
    let slotRange = appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots[index].slotRange;
    let availableSlots = appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots[index].availableSlots;
    let deletedAvlSlots = [...deletedAppointmentSlots];


    for(const weekDayName of total_weekdays){
      for(const avlslot of availableSlots){
         const payload = {
          slotRange,
          weekDayName,
          slotTime:{
            startTime:avlslot.startTime,
            endTime:avlslot.endTime
          }
         }

         deletedAvlSlots.push(payload);
      }
    }

    setDeletedAppointmentSlots(deletedAvlSlots);

    if(slotIndex>0) setSlotIndex(slotIndex - 1);
    const copyDays = [...selectedCopydays].map(day=>day.toLowerCase().substring(0,3));;
    setAppointmentSlots(oldstate=>{
      oldstate[selectedDay.toLowerCase().substring(0,3)].slots.splice(index,1);
      copyDays.forEach(day =>{
        oldstate[day].slots = oldstate[selectedDay.toLowerCase().substring(0,3)].slots;
      })
      return {...oldstate};
    });
  }

  const handleTempSelectTime=(type="start",timeType = "hr",value)=>event=>{

    if(timeType == "hr"){
      setTempSelectTime({
        ...tempSelectTime,
        hr:value
      })
    }else if(timeType == "min"){
        if(type == "start"){
          setStartTime({
            ...startTime,
            hr:tempSelectTime.hr,
            min:value
          })
        }else{
          setEndTime({
            ...endTime,
            hr:tempSelectTime.hr,
            min:value
          })
        }

        setTempSelectTime({
          ...tempSelectTime,
          hr:"",
          min:""
        })
  
        setTimeSelectorTime("");
       

 
  
    }
  }

  const handleTimeSelectorType = type =>{
    if(timeSelectorType == type) type = "";
    setTimeSelectorTime(type);
    if(type){
      setTempSelectTime({
        ...tempSelectTime,
        hr:"",
        min:""
      })
    }
  }

  const handleChangeTimePeriod = (type,period) =>{
    if(type == "start"){
      setStartTime({
        ...startTime,
        period
      })
    }else{
      setEndTime({
        ...endTime,
        period
      })
    }
  }

  const hanldeDaySelect = (day) =>{
    setSelectedDay(day);
    setSelectedCopydays([]);
    setGlobalBookingLimit(appointmentSlots[`${day}`.toLowerCase().substring(0,3)].slot_limit==undefined?1:appointmentSlots[`${day}`.toLowerCase().substring(0,3)].slot_limit)
    setAddedBookingLimit(appointmentSlots[`${day}`.toLowerCase().substring(0,3)].slot_limit==undefined?1:appointmentSlots[`${day}`.toLowerCase().substring(0,3)].slot_limit)
  }

  const handleAppointmentDuration = (time) => {

    let slots = [...appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots];
    let newSlots = []

    for(let slot of slots){
      let newStartTime = {...slot.slotRange.startTime};
      let newEndTime = {...slot.slotRange.endTime};

  
      if(newStartTime.hr && newStartTime.min && newEndTime.hr && newEndTime.min && newStartTime.period && newEndTime.period){
        let new_start_time_hour_24_format =  convertTo24Hour(`${newStartTime.hr}:${newStartTime.min!=""?newStartTime.min:0} ${newStartTime.period}`);
        let new_end_time_hour_24_format =  convertTo24Hour(`${newEndTime.hr}:${newEndTime.min!=""?newEndTime.min:0} ${newEndTime.period}`);
    
        const new_start_time = {
          hr:parseInt(new_start_time_hour_24_format.split(":")[0]),
          min:parseInt(new_start_time_hour_24_format.split(":")[1])
        }

        const new_end_time = {
          hr:parseInt(new_end_time_hour_24_format.split(":")[0]),
          min:parseInt(new_end_time_hour_24_format.split(":")[1])
        }

        let item = {
          slotRange:{
            startTime:{...newStartTime},
            endTime:{...newEndTime}
          },
          availableSlots:[]
        }
     

        item.availableSlots = findAvailableSlots(new_start_time,new_end_time,parseInt(time)-5).map(data=>({lock:false,startTime:{...data.start},endTime:{...data.end}}));

        newSlots.push(item);
        

      }
  
    }


    const copyDays = [...selectedCopydays].map(day=>day.toLowerCase().substring(0,3));

    setAppointmentSlots(oldstate=>{
      oldstate[selectedDay.toLowerCase().substring(0,3)].slot_duration=time;
      oldstate[selectedDay.toLowerCase().substring(0,3)].slots=newSlots;

      copyDays.forEach(data=>{
        oldstate[data].slot_duration=time;
        oldstate[data].slots=newSlots;
      })

      return {...oldstate};
    })
  }

  const handleSelectDate = event => {
    flatpickr = FlatPicker("#date-select", {
      disableMobile: true,
      onChange: (e) => {
        if(e.length>0) {
          if(new Date(e[0])<new Date(new Date().setHours(0,0,0,0))){
            return alert("Please note, selecting a previous date is not allowed. Kindly choose a current or future date");
          }
          setSelectedDate(e[0]);
        }
      }
    })
    flatpickr.open();
  }
  
  const handleUserSearchKey = value =>{
    setUserSearchKey(value);
  }

  const handleSelectUser = (user) => {
    
    setSelectUser(modalType == "edit-appointment"?user.user[0]:user)
    try{
      if(modalType == "edit-appointment"?user:(user.appointmentslots && user.appointmentslots.length>0)){
        const appointmentSlot = modalType == "edit-appointment"?user:user.appointmentslots[0]
        setSelectedDate(appointmentSlot.slotAssignDate);
        setAppointmentSlots({
          ...appointmentSlots,
          sun:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.sun.slot_limit==undefined?1:appointmentSlot.weekdays.sun.slot_limit,
            slot_duration:appointmentSlot.weekdays.sun.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.sun.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          },
          mon:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.mon.slot_limit == undefined?1:appointmentSlot.weekdays.mon.slot_limit,
            slot_duration:appointmentSlot.weekdays.mon.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.mon.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          },
          tue:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.tue.slot_limit == undefined?1:appointmentSlot.weekdays.tue.slot_limit,
            slot_duration:appointmentSlot.weekdays.tue.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.tue.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          },
          wed:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.wed.slot_limit == undefined?1:appointmentSlot.weekdays.wed.slot_limit,
            slot_duration:appointmentSlot.weekdays.wed.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.wed.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          },
          thu:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.thu.slot_limit == undefined?1:appointmentSlot.weekdays.thu.slot_limit,
            slot_duration:appointmentSlot.weekdays.thu.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.thu.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          },
          fri:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.fri.slot_limit == undefined?1:appointmentSlot.weekdays.fri.slot_limit,
            slot_duration:appointmentSlot.weekdays.fri.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.fri.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          },
          sat:{
            copyFrom:'',
            slot_limit:appointmentSlot.weekdays.sat.slot_limit == undefined?1:appointmentSlot.weekdays.sat.slot_limit,
            slot_duration:appointmentSlot.weekdays.sat.slot_duration,
            slots:!appointmentSlot.weekdays?[]:appointmentSlot.weekdays.sat.slots.map(data=>({slotRange:data.slotRange,availableSlots:data.availableSlots.map(d=>({...d,slot_limit:d.slot_limit == undefined ? 1 : d.slot_limit}))}))
          }
        })
        setGlobalBookingLimit(appointmentSlot.weekdays.mon.slot_limit==undefined?1:appointmentSlot.weekdays.mon.slot_limit)
        setAddedBookingLimit(appointmentSlot.weekdays.mon.slot_limit==undefined?1:appointmentSlot.weekdays.mon.slot_limit)
      }
    }catch(error){

    }
  }

  const handleCustomDuration = () => {
    setCustomDuration(!isCustomDuration)
  }

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleChange = event => {
    // if(currentElementId == "apt-duration"){
    //   setAppointmentDuration(event.target.value)
    // }
  }


  const handleChangeSelectedUser = () => {
    setSelectUser('')
  }

  const handleSelectSlotIndex = index =>{
    setSlotIndex(index);
  }

  const handleGroupClassName = event =>{
    setGroupClassName(event.target.value);
  };


  //api
  const getUserParams = () =>{
    let params = {
      pageNo:pageNo.user,
      pageSize:pageSize.user,
      isAllUser:true,
      roles:[3,4,5,6,7,10]
    };
    params.activationStatus = "activate";
    if (selectedBranch) params.gymIDs = [selectedBranch.gym[0]._id];
    if (selectedBranch) params.branchIDs = selectedBranch._id;
    if (userSearchKey) params.q = userSearchKey;

    return params;
  }

   const GetUsers = async (isReUpdateUsers) => {
     try {
       let params = getUserParams();
       let responses = await getUsersListV2(user._id, token, params);
       if(responses.error) return "";
       if(isReUpdateUsers) setUsersList(responses)
       else setUsersList([...usersList,...responses])
       setUsersList(responses)
     } catch (error) {
       console.error(error);
     }
   }
 
   const GetUserCount = async () => {
     try {
       let params = getUserParams();
       let attr = await getUsersCount(user._id, token, params);
       pageNo.user = 1;
       setPageNo(pageNo)
       total.user = attr.COUNT
       setTotal(total);
       pageCount.user = Math.ceil(attr.COUNT / pageSize)
       setPageCount(pageCount);
 
     } catch (error) {
       // do something
       console.error(error)
     }
   }
  //end - api


  const handleScroll = async event => {
    try{
      const { offsetHeight, scrollTop, scrollHeight } = event.target;

      if (offsetHeight + scrollTop === scrollHeight && pageNo.user < pageCount.user) {
        pageNo.user = pageNo.user + 1;
        setPageNo(pageNo)
        setUserSpinnerLoader(true)
        await GetUsers();
        setUserSpinnerLoader(false)
      }
    }catch(error){
      /// do something
      console.error(error)
    }
  }

  const handleScrollClasses = async event =>{
     try{
      const { offsetHeight, scrollTop, scrollHeight } = event.target;

      if (offsetHeight + scrollTop === scrollHeight && pageNo.user < pageCount.groupclass) {
        pageNo.groupclass = pageNo.groupclass + 1;
        setPageNo(pageNo)
        setStartGroupClassListLazyLoader(true)
        await GetAllGroupClass();
        setStartGroupClassListLazyLoader(false)
      }
    }catch(error){
      setStartGroupClassListLazyLoader(false)
      /// do something
      console.error(error)
    }
  }

  const handleBookingLimit = (actionType) => {
    if(actionType == "add"){
      setAddedBookingLimit(globalBookingLimit)
    }else{
      setAddedBookingLimit(null)
    }

    const copyDays = [...selectedCopydays].map(day=>day.toLowerCase().substring(0,3));

    setAppointmentSlots(oldstate=>{
      oldstate[selectedDay.toLowerCase().substring(0,3)].slot_limit=globalBookingLimit == null? 1: globalBookingLimit;
      oldstate[selectedDay.toLowerCase().substring(0,3)].slots.map(slot=>{
          slot.availableSlots.map(d=>{
            d.slot_limit = globalBookingLimit == null? 1: globalBookingLimit;
          });
      });
      copyDays.forEach(data=>{
        oldstate[data].slot_duration=globalBookingLimit == null? 1: globalBookingLimit;
        oldstate[data].slots.map(slot=>{
          slot.availableSlots.map(d=>{
            d.slot_limit = globalBookingLimit == null? 1: globalBookingLimit;
          });
        });
      })

      return {...oldstate};
    })
  }

  const handleBookingType = (type) => {
    if(type == "group-class") return new Toast({type:"info",duration:3000,message:`This feature is currently under development. Our team will notify you as soon as it’s live.\nWe apologize for any inconvenience caused and appreciate your patience.`})
    setBookingType(type)
  }

  const handleManageGroupClass = (groupClass) => {
    if(groupClass){
      setGroupClassName(groupClass)
    }


    if(isGroupClassInstructor == true){
      setGroupClassInstructor(false);
      setManageGroupClass(false);
    }else{
      setManageGroupClass(!manageGroupClass)
    }

  }

  const handleManageGroupClassInstructor = () => {
    if(isGroupClassInstructor == false){
      setGroupClassInstructor(true);
      setManageGroupClass(false);
    }else{
      setManageGroupClass(true);
    }
    
  }

  useEffect(()=>{
    if(startTime.hr!="" && endTime.hr!=""){
      let start_time_24_format = convertTo24Hour(`${startTime.hr}:${startTime.min!=""?startTime.min:0} ${startTime.period}`)
      let end_time_24_format =  convertTo24Hour(`${endTime.hr}:${endTime.min!=""?endTime.min:0} ${endTime.period}`);

      const startTime24 ={
        hr: parseInt(start_time_24_format.split(":")[0]),
        min: parseInt(start_time_24_format.split(":")[1])
      }
      
      const endTime24 ={
        hr: parseInt(end_time_24_format.split(":")[0]),
        min: parseInt(end_time_24_format.split(":")[1])
      }
    
      if(startTime24.hr>endTime24.hr){
        setEndTime({
          ...endTime,
          hr:"",
          min:""
        })
        new Toast({
          type:"warning",
          duration:3000,
          message:"End time should be less then start time"
        })
      }
    }

  },[startTime,endTime])

  useEffect(async ()=>{
    if(selectedBranch){
      try{
        setUserSpinnerLoader(true)
        await GetUsers(true);
        await GetUserCount();
        setUserSpinnerLoader(false)
      }catch(error){
        setUserSpinnerLoader(false)
      }
    }
  },[userSearchKey,selectedBranch]);

  useEffect(async ()=>{
    if(selectedBranch){
      try{
        setStartGroupClassListLazyLoader(true);
        await GetAllGroupClass(true);
        await GetGroupClassCount();
        setStartGroupClassListLazyLoader(false);
      }catch(error){
        setStartGroupClassListLazyLoader(false);
      }
    }
  },[selectedBranch,groupClassName])
  
  useEffect(()=>{
    if(selectedDate && selectedUser){
      setButtonLock(false);
    }else{
      setButtonLock(true);
    }
  },[selectedDate,selectedUser]);

  useEffect(()=>{
    if(modalType == "edit-appointment"){
      setSelectedBranch(props.selectedGym);
      handleSelectUser(props.selectedUser);
    }
  },[modalType]);

  useEffect(() => {
    if(props.modalType) setModalType(props.modalType);
  },[props.selectedUser])

  return(
    <div className="modal-test-container d-flex">
      <div className="appointment-action-modal slideBottomToTop flex-item">
        <div className="modal-header" style={{height:"64px"}}>
          {
            (selectedUser || manageGroupClass || isGroupClassInstructor) ? (
              <div className="d-flex space-between w-full">
                {
                  selectedUser ? (
                    <div onClick={()=>modalType == "edit-appointment"?null:handleChangeSelectedUser()} className="d-flex cursor-pointer">
                      {
                        selectedUser.profileID ? (
                          <img className='flex-item user-profile m-r-8' src={`${client.config.API_URL}/image/file/${selectedUser.profileID}/auto/auto/70`} />
                        ) : (
                          <div className='user-profile m-r-8 d-flex' style={{backgroundColor:'#5d883c'}}>
                            <p className='flex-item' style={{color: '#ffffff', fontSize: 14, margin: '0 auto'}}>{`${selectedUser.name}`.trim()[0]}</p>
                          </div>
                        )
                      }
                      <div className="flex-item">
                        <div className="d-flex">
                          <p className="flex-item fs-16 font-weight-700" style={{lineHeight:'16px'}}>{selectedUser.name}</p>
                          {modalType != "edit-appointment" && <svg className="flex-item m-l-8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7873 1.21157C10.4379 0.862254 9.96407 0.666016 9.47 0.666016C8.97593 0.666016 8.50209 0.862254 8.15271 1.21157L1.56417 7.8009C1.37203 7.99291 1.23946 8.23633 1.18241 8.5019L0.674542 10.8716C0.661149 10.9338 0.663565 10.9984 0.681569 11.0594C0.699573 11.1205 0.732591 11.1761 0.777606 11.2211C0.822622 11.2661 0.8782 11.2991 0.939263 11.3171C1.00033 11.3351 1.06493 11.3375 1.12716 11.3242L3.49695 10.8163C3.76253 10.7593 4.00597 10.6267 4.19798 10.4346L10.7873 3.84563C11.1365 3.49628 11.3327 3.02255 11.3327 2.5286C11.3327 2.03465 11.1365 1.56092 10.7873 1.21157ZM8.69182 1.75027C8.90014 1.55327 9.1771 1.4453 9.4638 1.44931C9.7505 1.45333 10.0243 1.56902 10.227 1.77178C10.4298 1.97454 10.5454 2.24838 10.5493 2.53506C10.5533 2.82175 10.4452 3.09866 10.2482 3.30693L9.90529 3.64981L8.34854 2.09353L8.69182 1.75027ZM7.80943 2.63222L9.36618 4.18888L3.65964 9.89626C3.57133 9.98452 3.4594 10.0454 3.33732 10.0715L1.54245 10.4563L1.92725 8.66191C1.95339 8.53983 2.01425 8.4279 2.10251 8.3396L7.80943 2.63222Z" fill="var(--darkBlue)"/>
                          </svg>}
                        </div>
                        <p className="flex-item fs-10 m-t-6" style={{lineHeight:'10px'}}>
                          {getUserRole(selectedUser.role)}
                          {/* {
                            selectedUser && selectedUser.designation && selectedUser.designation.map((data, index) => {
                              return(
                                <span>{data}{selectedUser.designation.length != index + 1 && ", "}</span>
                              )
                            })
                          } */}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div onClick={()=>handleManageGroupClass()} className="flex-item cursor-pointer">
                      <div className="d-flex">
                        <p className="fs-18 flex-item font-weight-700" style={{lineHeight:"18px"}}>{groupClassName}</p>
                        <svg className="flex-item m-l-12 cursor-pointer" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.7873 1.21157C10.4379 0.862254 9.96407 0.666016 9.47 0.666016C8.97593 0.666016 8.50209 0.862254 8.15271 1.21157L1.56417 7.8009C1.37203 7.99291 1.23946 8.23633 1.18241 8.5019L0.674542 10.8716C0.661149 10.9338 0.663565 10.9984 0.681569 11.0594C0.699573 11.1205 0.732591 11.1761 0.777606 11.2211C0.822622 11.2661 0.8782 11.2991 0.939263 11.3171C1.00033 11.3351 1.06493 11.3375 1.12716 11.3242L3.49695 10.8163C3.76253 10.7593 4.00597 10.6267 4.19798 10.4346L10.7873 3.84563C11.1365 3.49628 11.3327 3.02255 11.3327 2.5286C11.3327 2.03465 11.1365 1.56092 10.7873 1.21157ZM8.69182 1.75027C8.90014 1.55327 9.1771 1.4453 9.4638 1.44931C9.7505 1.45333 10.0243 1.56902 10.227 1.77178C10.4298 1.97454 10.5454 2.24838 10.5493 2.53506C10.5533 2.82175 10.4452 3.09866 10.2482 3.30693L9.90529 3.64981L8.34854 2.09353L8.69182 1.75027ZM7.80943 2.63222L9.36618 4.18888L3.65964 9.89626C3.57133 9.98452 3.4594 10.0454 3.33732 10.0715L1.54245 10.4563L1.92725 8.66191C1.95339 8.53983 2.01425 8.4279 2.10251 8.3396L7.80943 2.63222Z" fill="var(--darkBlue)"/>
                        </svg>
                      </div>
                      <div className="d-flex">
                        <svg className="flex-item m-r-8" width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 7.14518C4.5264 7.14518 4.0722 6.95861 3.73731 6.62652C3.40242 6.29442 3.21429 5.844 3.21429 5.37435C3.21429 4.9047 3.40242 4.45428 3.73731 4.12218C4.0722 3.79009 4.5264 3.60352 5 3.60352C5.4736 3.60352 5.9278 3.79009 6.26269 4.12218C6.59758 4.45428 6.78571 4.9047 6.78571 5.37435C6.78571 5.6069 6.73953 5.83717 6.64979 6.05202C6.56004 6.26687 6.42851 6.46208 6.26269 6.62652C6.09687 6.79095 5.90002 6.92139 5.68336 7.01039C5.46671 7.09938 5.2345 7.14518 5 7.14518ZM5 0.416016C3.67392 0.416016 2.40215 0.93841 1.46447 1.86828C0.526784 2.79815 0 4.05932 0 5.37435C0 9.0931 5 14.5827 5 14.5827C5 14.5827 10 9.0931 10 5.37435C10 4.05932 9.47322 2.79815 8.53553 1.86828C7.59785 0.93841 6.32608 0.416016 5 0.416016Z" fill="#CC0000"/>
                        </svg>
                        <p className="flex-item fs-12 color-grey-02">{selectedBranch.name}</p>
                      </div>
                    </div>
                  )
                }
                <div className="flex-item d-flex">
                  <div className="flex-item m-r-8" style={{background:"#EFFAFF", padding:"4px 12px", borderRadius:"8px"}}>
                    <p className="fs-16 font-weight-600">{selectedUser ? "Appointment Slots" : "Group Class Slots"}</p>
                  </div>
                  <div onClick={()=>props.toggleCreateAppointment()} className="global-round-btn d-flex">
                    <svg className="flex-item fill-svg" width="16" height="16" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black"/>
                    </svg>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full h-full d-flex space-between">
                <p className="flex-item fs-22 font-weight-700">Create Session</p>
                <div onClick={()=>props.toggleCreateAppointment()} className="global-round-btn d-flex">
                  <svg className="flex-item fill-svg" width="16" height="16" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black"/>
                  </svg>
                </div>
              </div>
            )
          }
        </div>
        {
          (selectedUser || manageGroupClass) ? (
            <div className="appointment-planner-container d-flex space-between">
              <div className="flex-item weekdays-container">
                <div onClick={hanldeDaySelect.bind(this,"Monday")} className={`day-container button-blue ${selectedDay == 'Monday' && `bg-blue`}`}>
                  <p className={selectedDay == "Monday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Monday</p>
                </div>
                <div onClick={hanldeDaySelect.bind(this,"Tuesday")} className={`day-container button-blue ${selectedDay == 'Tuesday' && `bg-blue`}`}>
                  <p className={selectedDay == "Tuesday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Tuesday</p>
                </div>
                <div onClick={hanldeDaySelect.bind(this,"Wednesday")} className={`day-container button-blue ${selectedDay == 'Wednesday' && `bg-blue`}`}>
                  <p className={selectedDay == "Wednesday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Wednesday</p>
                </div>
                <div onClick={hanldeDaySelect.bind(this,"Thursday")} className={`day-container button-blue ${selectedDay == 'Thursday' && `bg-blue`}`}>
                  <p className={selectedDay == "Thursday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Thursday</p>
                </div>
                <div onClick={hanldeDaySelect.bind(this,"Friday")} className={`day-container button-blue ${selectedDay == 'Friday' && `bg-blue`}`}>
                  <p className={selectedDay == "Friday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Friday</p>
                </div>
                <div onClick={hanldeDaySelect.bind(this,"Saturday")} className={`day-container button-blue ${selectedDay == 'Saturday' && `bg-blue`}`}>
                  <p className={selectedDay == "Saturday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Saturday</p>
                </div>
                <div onClick={hanldeDaySelect.bind(this,"Sunday")} className={`day-container button-blue ${selectedDay == 'Sunday' && `bg-blue`}`}>
                  <p className={selectedDay == "Sunday"?"color-white font-style-2":"color-black font-style-2 font-weight-300"}>Sunday</p>
                </div>
              </div>
              <div className="flex-item day-appt-planner-container">
                <div className="appt-planner-header space-between d-flex">
                  <div className="d-flex">
                    <p className="flex-item m-r-14">Copy To</p>
                    <div className="d-flex">
                      {
                        [
                        selectedDay != "Monday" && <div onClick={()=>handleCopydays("Monday")} className="global-round-btn d-flex m-r-6" style={{background:selectedCopydays.indexOf("Monday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Monday") != -1 &&`color-blue`}`}>M</p>
                        </div>,
                         selectedDay != "Tuesday" && <div onClick={()=>handleCopydays("Tuesday")} className="global-round-btn d-flex m-r-6" style={{background:selectedCopydays.indexOf("Tuesday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Tuesday") != -1 && `color-blue`}`}>T</p>
                        </div>,
                        selectedDay != "Wednesday" && <div onClick={()=>handleCopydays("Wednesday")} className="global-round-btn d-flex m-r-6" style={{background:selectedCopydays.indexOf("Wednesday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Wednesday") != -1 && `color-blue`}`}>W</p>
                        </div>,
                        selectedDay != "Thursday" && <div onClick={()=>handleCopydays("Thursday")} className="global-round-btn d-flex m-r-6"  style={{background:selectedCopydays.indexOf("Thursday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Thursday") != -1 && `color-blue`}`}>T</p>
                        </div>,
                        selectedDay != "Friday" && <div onClick={()=>handleCopydays("Friday")} className="global-round-btn d-flex m-r-6" style={{background:selectedCopydays.indexOf("Friday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Friday") != -1 && `color-blue`}`}>F</p>
                        </div>,
                        selectedDay != "Saturday" && <div onClick={()=>handleCopydays("Saturday")} className="global-round-btn d-flex m-r-6" style={{background:selectedCopydays.indexOf("Saturday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Saturday") != -1 && `color-blue`}`}>S</p>
                        </div>,
                        selectedDay != "Sunday" && <div onClick={()=>handleCopydays("Sunday")} className="global-round-btn d-flex m-r-6" style={{background:selectedCopydays.indexOf("Sunday") != -1 && "#DFF3FF"}}>
                          <p className={`text flex-item ${selectedCopydays.indexOf("Sunday") != -1 && `color-blue`}`}>S</p>
                        </div>
                        ]
                      }
                    </div>
                  </div>
                  <div className="global-round-btn button-orange bg-orange d-flex m-r-6">
                    <svg onClick={resetCopyFromSelection} className="flex-item" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.41303 4.08027C8.9564 3.62142 8.4134 3.25756 7.81539 3.00971C7.21737 2.76187 6.57618 2.63493 5.92884 2.63624C4.62163 2.63624 3.36796 3.15553 2.44362 4.07986C1.51929 5.0042 1 6.25787 1 7.56508C1.00016 8.87281 1.5193 10.127 2.44343 11.0523C3.36755 11.9776 4.62111 12.4983 5.92884 12.5001C7.23668 12.4983 8.49033 11.9775 9.41447 11.0521C10.3386 10.1267 10.8577 8.8723 10.8577 7.56446" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                      <path d="M8.96436 1L9.5549 3.39822C9.60697 3.61078 9.57278 3.83531 9.45979 4.02273C9.3468 4.21015 9.16421 4.34522 8.95193 4.39841L6.54688 4.9877" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div className="appt-day-planner-scroll-container">
                  <p className="flex-item font-style-2 font-weight-600 color-grey-02">Select Appointment Duration</p>
                  <div onClick={()=>handleCustomDuration()} className="d-flex cursor-pointer">
                    <p className="fs-12 m-r-6 font-weight-300">Add Custom Duration</p>
                    <svg className="flex-item m-t-2" style={{transition:"180ms", transform: isCustomDuration ? "rotate(45deg)" : "rotate(0deg)"}} width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.99781 2.1692C4.99654 2.09632 4.9667 2.02686 4.91472 1.97577C4.86273 1.92468 4.79276 1.89605 4.71987 1.89605C4.64698 1.89605 4.57701 1.92468 4.52502 1.97577C4.47304 2.02686 4.4432 2.09632 4.44193 2.1692L4.44193 4.4395L2.17144 4.4393C2.13453 4.43866 2.09787 4.44537 2.06358 4.45905C2.0293 4.47273 1.99809 4.4931 1.97176 4.51898C1.94543 4.54485 1.92452 4.57571 1.91025 4.60975C1.89598 4.64379 1.88863 4.68033 1.88863 4.71724C1.88863 4.75415 1.89598 4.79069 1.91025 4.82473C1.92452 4.85877 1.94543 4.88963 1.97176 4.9155C1.99809 4.94138 2.0293 4.96175 2.06359 4.97543C2.09787 4.98911 2.13453 4.99582 2.17144 4.99518L4.44193 4.99538L4.44193 7.26567C4.4432 7.33855 4.47304 7.40801 4.52502 7.4591C4.57701 7.51019 4.64698 7.53882 4.71987 7.53882C4.79276 7.53882 4.86273 7.51019 4.91472 7.4591C4.9667 7.40801 4.99654 7.33855 4.99781 7.26567L4.99781 4.99538L7.26811 4.99538C7.34098 4.99411 7.41045 4.96427 7.46154 4.91228C7.51263 4.8603 7.54126 4.79033 7.54126 4.71744C7.54126 4.64455 7.51263 4.57458 7.46154 4.52259C7.41045 4.4706 7.34098 4.44076 7.26811 4.4395L4.99781 4.4395L4.99801 2.169L4.99781 2.1692Z" fill="#4D4D4D"/>
                    </svg>
                  </div>
                  {
                    isCustomDuration ? (
                      <div onClick={toggleInputFields('apt-duration')} className={`${(currentElementId == 'apt-duration' || appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-t-6 m-b-20`} style={{ border: (currentElementId == 'apt-duration' || appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'apt-duration' || appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration) ? "10px" : "14px", color: (currentElementId == 'apt-duration' || appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration) ? "var(--darkBlue)" : "", transition: "180ms" }}>Appointment Duration</p>
                        </div>
                        <input value={appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration} onChange={(e)=>handleAppointmentDuration(e.target.value)} className={`${(currentElementId == 'apt-duration' || appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                      </div>
                    ) : (
                      <div className='w-full d-flex-wrap m-b-8 m-t-14'>
                        <div className='m-r-12' style={{textAlign:"center", alignSelf:"flex-start"}}>
                          <div onClick={() => handleAppointmentDuration(15)} className={`${appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration == 15 ? "global-selection-chips global-selection-chips-active" : "global-selection-chips"} d-flex cursor-pointer`}>
                            <p className='flex-item'>15 Min</p>
                          </div>
                          <p className='fs-10' style={{color: appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration == 15 ? "var(--darkBlue)" : "#9a9a9a"}}>Optimal Time</p>
                        </div>
                        <div onClick={() => handleAppointmentDuration(30)} className={`${appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration == 30 ? "global-selection-chips global-selection-chips-active m-r-12 m-b-16" : "global-selection-chips m-r-12 m-b-16"} d-flex cursor-pointer`} style={{textAlign:"center", alignSelf:"flex-start"}}>
                          <p className='flex-item'>30 Min</p>
                        </div>
                        <div onClick={() => handleAppointmentDuration(45)} className={`${appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration == 45 ? "global-selection-chips global-selection-chips-active m-r-12 m-b-16" : "global-selection-chips m-r-12 m-b-16"} d-flex cursor-pointer`} style={{textAlign:"center", alignSelf:"flex-start"}}>
                          <p className='flex-item'>45 Min</p>
                        </div>
                        <div onClick={() => handleAppointmentDuration(60)} className={`${appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slot_duration == 60 ? "global-selection-chips global-selection-chips-active m-r-12 m-b-16" : "global-selection-chips m-r-12 m-b-16"} d-flex cursor-pointer`} style={{textAlign:"center", alignSelf:"flex-start"}}>
                          <p className='flex-item'>60 Min</p>
                        </div>
                      </div>
                    )
                  }

                  <div className="flex-item w-full m-b-16">
                    <p className="flex-item font-style-2 font-weight-600 color-grey-02 m-b-4">Maximum Allowed Bookings</p>
                    {
                      addedBookingLimit != null ? (
                        <div className="d-flex">
                          <div className="p-l-12 p-r-12 p-t-4 p-b-4 bg-dark-blue d-flex flex-item cursor-pointer" style={{borderRadius:"10px"}}>
                            <p className="flex-item m-r-12 fs-18 font-weight-600 color-white">{addedBookingLimit}</p>
                            <svg onClick={()=>handleBookingLimit("remove")} className="flex-item" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.2587 5.2909C14.3942 5.15207 14.4696 4.9656 14.4689 4.77166C14.4682 4.57772 14.3913 4.39183 14.2549 4.25401C14.1184 4.1162 13.9333 4.03749 13.7393 4.03485C13.5454 4.0322 13.3582 4.10583 13.2181 4.23987L8.92548 8.49014L4.67521 4.19682C4.60733 4.12584 4.52599 4.06909 4.43595 4.02988C4.3459 3.99067 4.24894 3.96978 4.15074 3.96844C4.05253 3.9671 3.95505 3.98533 3.86396 4.02207C3.77288 4.05881 3.69003 4.11332 3.62023 4.18243C3.55044 4.25153 3.49512 4.33384 3.45747 4.42456C3.41983 4.51527 3.40064 4.61257 3.401 4.71079C3.40137 4.809 3.4213 4.90616 3.45961 4.99659C3.49793 5.08702 3.55387 5.16891 3.62418 5.23749L7.87445 9.53081L3.58187 13.7811C3.44644 13.9199 3.37097 14.1064 3.37169 14.3003C3.37242 14.4943 3.44928 14.6802 3.58574 14.818C3.7222 14.9558 3.90732 15.0345 4.10125 15.0371C4.29517 15.0398 4.48237 14.9662 4.62254 14.8321L8.91512 10.5818L13.1654 14.8744C13.3042 15.0098 13.4907 15.0853 13.6846 15.0846C13.8786 15.0839 14.0645 15.007 14.2023 14.8705C14.3401 14.7341 14.4188 14.549 14.4214 14.355C14.4241 14.1611 14.3505 13.9739 14.2164 13.8337L9.96615 9.54117L14.2595 5.2909L14.2587 5.2909Z" fill="#E33A34"/>
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <div onClick={toggleInputFields('global-booking-limit')} className={`${(currentElementId == 'global-booking-limit' || globalBookingLimit) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'global-booking-limit' || globalBookingLimit) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                            <div className="flex-item d-flex">
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'global-booking-limit' || globalBookingLimit) ? "10px" : "14px", color: (currentElementId == 'global-booking-limit' || globalBookingLimit) ? "var(--darkBlue)" : "", transition: "180ms" }}>Booking Limit</p>
                            </div>
                            <input value={globalBookingLimit} onChange={(event)=>setGlobalBookingLimit(event.target.value)} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'global-booking-limit' || globalBookingLimit) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                          </div>
                          {
                            globalBookingLimit > 0 && (
                              <div onClick={()=>handleBookingLimit("add")} className="global-round-btn global-round-btn-active d-flex flex-item m-l-16">
                                <svg className="flex-item fill-svg" width="20" height="20" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.99781 2.1692C4.99654 2.09632 4.9667 2.02686 4.91472 1.97577C4.86273 1.92468 4.79276 1.89605 4.71987 1.89605C4.64698 1.89605 4.57701 1.92468 4.52502 1.97577C4.47304 2.02686 4.4432 2.09632 4.44193 2.1692L4.44193 4.4395L2.17144 4.4393C2.13453 4.43866 2.09787 4.44537 2.06358 4.45905C2.0293 4.47273 1.99809 4.4931 1.97176 4.51898C1.94543 4.54485 1.92452 4.57571 1.91025 4.60975C1.89598 4.64379 1.88863 4.68033 1.88863 4.71724C1.88863 4.75415 1.89598 4.79069 1.91025 4.82473C1.92452 4.85877 1.94543 4.88963 1.97176 4.9155C1.99809 4.94138 2.0293 4.96175 2.06359 4.97543C2.09787 4.98911 2.13453 4.99582 2.17144 4.99518L4.44193 4.99538L4.44193 7.26567C4.4432 7.33855 4.47304 7.40801 4.52502 7.4591C4.57701 7.51019 4.64698 7.53882 4.71987 7.53882C4.79276 7.53882 4.86273 7.51019 4.91472 7.4591C4.9667 7.40801 4.99654 7.33855 4.99781 7.26567L4.99781 4.99538L7.26811 4.99538C7.34098 4.99411 7.41045 4.96427 7.46154 4.91228C7.51263 4.8603 7.54126 4.79033 7.54126 4.71744C7.54126 4.64455 7.51263 4.57458 7.46154 4.52259C7.41045 4.4706 7.34098 4.44076 7.26811 4.4395L4.99781 4.4395L4.99801 2.169L4.99781 2.1692Z" fill="#4D4D4D"/>
                                </svg>
                              </div>
                            )
                          }
                        </div>
                      )
                    }
                  </div>

                  <p className="flex-item font-style-2 font-weight-600 color-grey-02 m-b-4">Duty Time For Appointments</p>
                  <div className="d-flex">
                    <div className="member-global-input-field flex-item m-r-12" style={{border: "1px solid var(--darkBlue)", width: "170px", height: "46px"}}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: "10px", color:"var(--darkBlue)", transition: "180ms"}}>From</p>
                      </div>
                      <div className="d-flex w-full space-between">
                        <div onClick={handleTimeSelectorType.bind(this,"start")} className="d-flex">
                          <p className="flex-item" style={{color: "#2b2b2b", lineHeight:"14px"}}>{startTime.hr ? startTime.hr : "00"}</p>
                          <svg className="flex-item m-l-4 m-r-4" width="3" height="6" viewBox="0 0 3 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 0.667969 2)" fill="black"/>
                            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 0.667969 6)" fill="black"/>
                          </svg>
                          <p className="flex-item" style={{color: "#2b2b2b", lineHeight:"14px"}}>{startTime.min ? startTime.min : "00"}</p>
                        </div>
                        <div className="time-period-switch d-flex" style={{marginTop:"-15px"}}>
                          <div className="active-switch" style={{left:startTime.period=="AM"?0:'50%'}}>
                          </div>
                          <div className="period-container d-flex" onClick={handleChangeTimePeriod.bind(this,"start","AM")}>
                            <p className="flex-item font-style-3 color-blue">AM</p>
                          </div>
                          <div className="period-container d-flex" onClick={handleChangeTimePeriod.bind(this,"start","PM")}>
                            <p className="flex-item font-style-3">PM</p>
                          </div>
                        </div>
                      </div>
                      {
                        timeSelectorType == "start" && (
                          <div onClick={e => e.stopPropagation()} className="global-input-field-arrow-dropdown" style={{justifyContent:"center", textAlign:"center", width: "160px"}}>
                            <div className="d-flex space-between" style={{width: "150px", margin:"12px auto"}}>
                              <div className="d-flex flex-item" style={{width: "40%"}}>
                                <p className="flex-item" style={{margin: "0 auto", color: "var(--darkBlue)"}}>Hr</p>
                              </div>
                              <div className="flex-item" style={{width: "20%"}}>
                                <svg className="flex-item" width="4" height="10" viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="1.9987" cy="1.66667" r="1.66667" fill="#8F8F8F"/>
                                  <circle cx="1.9987" cy="8.33317" r="1.66667" fill="#8F8F8F"/>
                                </svg>
                              </div>
                              <div className="d-flex flex-item" style={{width: "40%", textAlign:"center"}}>
                                <p className="flex-item"  style={{margin: "0 auto", color: "var(--darkBlue)"}}>Min</p>
                              </div>
                            </div>
                            <div className="d-flex space-between" style={{width: "150px", height: "200px", margin:"12px auto"}}>
                              <div className="scroll-hidden" style={{width: "40%", textAlign:"center", height: "100%", overflowY:"auto"}}>
                                {
                                  time.hr.map(data => {
                                    return(
                                      <p className="flex-item" style={{margin: "0 auto",border:tempSelectTime.hr == data?'0.5px solid #e0e0e0':"",borderRadius:tempSelectTime.hr == data?'4px':""}} onClick={handleTempSelectTime("start","hr",data)}>{data}</p>
                                    )
                                    // onClick={() => handleAppointmentDuration(data, "")} 
                                  })
                                }
                              </div>
                              <div className="flex-item d-flex" style={{width: "20%"}}>
                                <div className="flex-item" style={{height: "200px", width: "0.5px", margin: "0 auto", background: "#0088DA"}} />
                              </div>
                              <div className="scroll-hidden" style={{width: "40%", textAlign:"center", height: "100%", overflowY:"auto"}}>
                                {
                                  time.min.map(data => {
                                    return(
                                      <p  className="flex-item" style={{margin: "0 auto",border:tempSelectTime.min == data?'0.5px solid #e0e0e0':"",borderRadius:tempSelectTime.min == data?'4px':""}} onClick={handleTempSelectTime("start","min",data)}>{data}</p>
                                    )
                                  })
                                }
                                {/* onClick={() => handleAppointmentDuration("", data)} */}
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className="member-global-input-field flex-item m-r-12" style={{border: "1px solid var(--darkBlue)", width: "170px", height: "46px"}}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: "10px", color:"var(--darkBlue)", transition: "180ms"}}>To</p>
                      </div>
                      <div className="d-flex w-full space-between">
                        <div className="d-flex" onClick={handleTimeSelectorType.bind(this,"end")}>
                          <p className="flex-item" style={{color: "#2b2b2b", lineHeight:"14px"}}>{endTime.hr ? endTime.hr : "00"}</p>
                          <svg className="flex-item m-l-4 m-r-4" width="3" height="6" viewBox="0 0 3 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 0.667969 2)" fill="black"/>
                            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 0.667969 6)" fill="black"/>
                          </svg>
                          <p className="flex-item" style={{color: "#2b2b2b", lineHeight:"14px"}}>{endTime.min ? endTime.min : "00"}</p>
                        </div>
                        <div className="time-period-switch d-flex" style={{marginTop:"-15px"}}>
                          <div className="active-switch" style={{left:endTime.period=="AM"?0:'50%'}}>
                          </div>
                          <div className="period-container d-flex" onClick={handleChangeTimePeriod.bind(this,"end","AM")}>
                            <p className="flex-item font-style-3 color-blue">AM</p>
                          </div>
                          <div className="period-container d-flex" onClick={handleChangeTimePeriod.bind(this,"end","PM")}>
                            <p className="flex-item font-style-3">PM</p>
                          </div>
                        </div>
                      </div>
                      {
                        timeSelectorType == "end" && (
                          <div onClick={e => e.stopPropagation()} className="global-input-field-arrow-dropdown" style={{justifyContent:"center", textAlign:"center", width: "160px"}}>
                            <div className="d-flex space-between" style={{width: "150px", margin:"12px auto"}}>
                              <div className="d-flex flex-item" style={{width: "40%"}}>
                                <p className="flex-item" style={{margin: "0 auto", color: "var(--darkBlue)"}}>Hr</p>
                              </div>
                              <div className="flex-item" style={{width: "20%"}}>
                                <svg className="flex-item" width="4" height="10" viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="1.9987" cy="1.66667" r="1.66667" fill="#8F8F8F"/>
                                  <circle cx="1.9987" cy="8.33317" r="1.66667" fill="#8F8F8F"/>
                                </svg>
                              </div>
                              <div className="d-flex flex-item" style={{width: "40%", textAlign:"center"}}>
                                <p className="flex-item"  style={{margin: "0 auto", color: "var(--darkBlue)"}}>Min</p>
                              </div>
                            </div>
                            <div className="d-flex space-between" style={{width: "150px", height: "200px", margin:"12px auto"}}>
                              <div className="scroll-hidden" style={{width: "40%", textAlign:"center", height: "100%", overflowY:"auto"}}>
                                {
                                  time.hr.map(data => {
                                    return(
                                      <p onClick={handleTempSelectTime("end","hr",data)}  className="flex-item" style={{margin: "0 auto",border:tempSelectTime.hr == data?'0.5px solid #e0e0e0':"",borderRadius:tempSelectTime.hr == data?'4px':""}}>{data}</p>
                                    )
                                  })
                                }
                              </div>
                              <div className="flex-item d-flex" style={{width: "20%"}}>
                                <div className="flex-item" style={{height: "200px", width: "0.5px", margin: "0 auto", background: "#0088DA"}} />
                              </div>
                              <div className="scroll-hidden" style={{width: "40%", textAlign:"center", height: "100%", overflowY:"auto"}}>
                                {
                                  time.min.map(data => {
                                    return(
                                      <p onClick={handleTempSelectTime("end","min",data)} className="flex-item" style={{margin: "0 auto",border:tempSelectTime.min == data?'0.5px solid #e0e0e0':"",borderRadius:tempSelectTime.min == data?'4px':""}}>{data}</p>
                                    )
                                  })
                                }
                              </div>
                            </div>


                          </div>
                        )
                      }
                    </div>
                    <div onClick={addNewSlot} className="global-round-btn d-flex">
                      <svg className="flex-item fill-svg" width="20" height="20" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.99781 2.1692C4.99654 2.09632 4.9667 2.02686 4.91472 1.97577C4.86273 1.92468 4.79276 1.89605 4.71987 1.89605C4.64698 1.89605 4.57701 1.92468 4.52502 1.97577C4.47304 2.02686 4.4432 2.09632 4.44193 2.1692L4.44193 4.4395L2.17144 4.4393C2.13453 4.43866 2.09787 4.44537 2.06358 4.45905C2.0293 4.47273 1.99809 4.4931 1.97176 4.51898C1.94543 4.54485 1.92452 4.57571 1.91025 4.60975C1.89598 4.64379 1.88863 4.68033 1.88863 4.71724C1.88863 4.75415 1.89598 4.79069 1.91025 4.82473C1.92452 4.85877 1.94543 4.88963 1.97176 4.9155C1.99809 4.94138 2.0293 4.96175 2.06359 4.97543C2.09787 4.98911 2.13453 4.99582 2.17144 4.99518L4.44193 4.99538L4.44193 7.26567C4.4432 7.33855 4.47304 7.40801 4.52502 7.4591C4.57701 7.51019 4.64698 7.53882 4.71987 7.53882C4.79276 7.53882 4.86273 7.51019 4.91472 7.4591C4.9667 7.40801 4.99654 7.33855 4.99781 7.26567L4.99781 4.99538L7.26811 4.99538C7.34098 4.99411 7.41045 4.96427 7.46154 4.91228C7.51263 4.8603 7.54126 4.79033 7.54126 4.71744C7.54126 4.64455 7.51263 4.57458 7.46154 4.52259C7.41045 4.4706 7.34098 4.44076 7.26811 4.4395L4.99781 4.4395L4.99801 2.169L4.99781 2.1692Z" fill="#4D4D4D"/>
                      </svg>
                    </div>
                  </div>
                  {
                    appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots.length > 0 && (
                      <div className="d-flex-wrap w-full m-t-20">
                      {
                        appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots.map((data, index) => {
                          return(
                            <div onClick={handleSelectSlotIndex.bind(this,index)} className={`time-slots-container cursor-pointer d-flex m-b-12 m-r-12 ${slotIndex == index && `time-slots-container-active`}`}>
                              <p className="flex-item">{`${data.slotRange.startTime.hr}:${data.slotRange.startTime.min} ${data.slotRange.startTime.period}`} - {`${data.slotRange.endTime.hr}:${data.slotRange.endTime.min} ${data.slotRange.endTime.period}`}</p>
                              <svg className="svg-fill flex-item m-l-12" onClick={removeSlot(index)} width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0276 4.47881C12.1399 4.36361 12.2026 4.20888 12.202 4.04795C12.2014 3.88702 12.1376 3.73276 12.0243 3.6184C11.9111 3.50404 11.7575 3.43873 11.5966 3.43654C11.4357 3.43434 11.2803 3.49544 11.164 3.60666L7.60201 7.13355L4.07512 3.57094C4.0188 3.51204 3.9513 3.46495 3.87658 3.43241C3.80186 3.39987 3.72141 3.38255 3.63992 3.38143C3.55842 3.38032 3.47753 3.39545 3.40195 3.42594C3.32637 3.45642 3.25761 3.50166 3.1997 3.559C3.14179 3.61634 3.09588 3.68464 3.06464 3.75992C3.03341 3.83519 3.01748 3.91594 3.01778 3.99743C3.01809 4.07893 3.03462 4.15955 3.06642 4.23459C3.09821 4.30963 3.14463 4.37759 3.20297 4.4345L6.72986 7.99711L3.16786 11.524C3.05549 11.6392 2.99286 11.7939 2.99346 11.9549C2.99406 12.1158 3.05785 12.27 3.17108 12.3844C3.28431 12.4988 3.43793 12.5641 3.59885 12.5663C3.75976 12.5685 3.91511 12.5074 4.03142 12.3961L7.59341 8.86926L11.1203 12.4313C11.2355 12.5436 11.3902 12.6063 11.5512 12.6057C11.7121 12.6051 11.8664 12.5413 11.9807 12.428C12.0951 12.3148 12.1604 12.1612 12.1626 12.0003C12.1648 11.8394 12.1037 11.684 11.9925 11.5677L8.46556 8.0057L12.0282 4.47882L12.0276 4.47881Z" fill="#E33A34"/>
                              </svg>
                            </div>
                          )
                        })
                      }
                      </div>
                    )
                  }

                  <p className="flex-item font-style-2 font-weight-600 color-grey-02 m-b-4 m-t-12">Generated Appointment Slots</p>
                  <p className="fs-12 color-red font-weight-600 m-b-20" style={{lineHeight:"12px"}}>Note: 5 minutes buffer time *</p>
                  <div className="w-full">
                    {
                       appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots.length>0 && appointmentSlots[selectedDay.toLowerCase().substring(0,3)].slots[slotIndex].availableSlots.map((timeSlot, index) => {
                        return(
                          <div className="time-slots-container w-full cursor-pointer d-flex m-b-12 m-r-12 space-between">
                            <div className="flex-item d-flex">
                              <p className="flex-item">{`${timeSlot.startTime.hr}:${timeSlot.startTime.min} ${timeSlot.startTime.period}`} - {`${timeSlot.endTime.hr}:${timeSlot.endTime.min} ${timeSlot.endTime.period}`}</p>
                              <div className="flex-item m-r-12 m-l-12 bg-grey-06" style={{height:'20px', width:"1px"}} />
                              <p className="flex-item font-weight-700 color-dark-blue" style={{width:"80px"}}>{timeSlot.slot_limit} <span className="flex-item font-weight-400">Bookings</span></p>
                              <div onClick={()=> handleManageSlotBookingLimit(selectedDay.toLowerCase().substring(0, 3), slotIndex, index, "add")} className="global-round-btn d-flex m-l-12 flex-item bg-grey-10">
                                <svg className="flex-item stroke-svg" width="12" height="12" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8.24609 4.75134L4.45401 1.00195L0.746094 4.75134" stroke="#0088da" stroke-linecap="round"/>
                                </svg>
                              </div>
                              <div  onClick={()=>handleManageSlotBookingLimit(selectedDay.toLowerCase().substring(0, 3), slotIndex, index, "remove")} className="global-round-btn d-flex m-l-12 flex-item bg-grey-10">
                                <svg className="flex-item stroke-svg" width="12" height="12" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0.744141 1.00257L4.53622 4.75195L8.24414 1.00257" stroke="#0088da" stroke-linecap="round"/>
                                </svg>
                              </div>
                            </div>
                            <svg className="svg-fill flex-item" onClick={()=>removeTimeSlot(index)} width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.0276 4.47881C12.1399 4.36361 12.2026 4.20888 12.202 4.04795C12.2014 3.88702 12.1376 3.73276 12.0243 3.6184C11.9111 3.50404 11.7575 3.43873 11.5966 3.43654C11.4357 3.43434 11.2803 3.49544 11.164 3.60666L7.60201 7.13355L4.07512 3.57094C4.0188 3.51204 3.9513 3.46495 3.87658 3.43241C3.80186 3.39987 3.72141 3.38255 3.63992 3.38143C3.55842 3.38032 3.47753 3.39545 3.40195 3.42594C3.32637 3.45642 3.25761 3.50166 3.1997 3.559C3.14179 3.61634 3.09588 3.68464 3.06464 3.75992C3.03341 3.83519 3.01748 3.91594 3.01778 3.99743C3.01809 4.07893 3.03462 4.15955 3.06642 4.23459C3.09821 4.30963 3.14463 4.37759 3.20297 4.4345L6.72986 7.99711L3.16786 11.524C3.05549 11.6392 2.99286 11.7939 2.99346 11.9549C2.99406 12.1158 3.05785 12.27 3.17108 12.3844C3.28431 12.4988 3.43793 12.5641 3.59885 12.5663C3.75976 12.5685 3.91511 12.5074 4.03142 12.3961L7.59341 8.86926L11.1203 12.4313C11.2355 12.5436 11.3902 12.6063 11.5512 12.6057C11.7121 12.6051 11.8664 12.5413 11.9807 12.428C12.0951 12.3148 12.1604 12.1612 12.1626 12.0003C12.1648 11.8394 12.1037 11.684 11.9925 11.5677L8.46556 8.0057L12.0282 4.47882L12.0276 4.47881Z" fill="#E33A34"/>
                            </svg>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          ) : isGroupClassInstructor ? (
            <div className="w-full" style={{padding:"12px 0", height:"91%"}}>
              <div className="w-full" style={{padding:"0 12px"}}>
                <SearchFilter count={"0"} searchingData={handleUserSearchKey} searchType={"Instructor"} isSearchEnabled={true} isFilterEnabled={false} />
              </div>
              <div className="w-full m-t-10 p-l-12 p-r-12 apt-user-selection-container" onScroll={handleScroll}>
                {
                  usersList.map(userData => {
                    return(
                      <div className="d-flex cursor-pointer apt-user">
                        <input className="flex-item m-r-12" type="checkbox" style={{width:'16px', height:"16px"}} />
                        {
                          userData.profileID ? (
                            <img className='flex-item user-profile m-r-8' src={`${client.config.API_URL}/image/file/${userData.profileID}/auto/auto/70`} />
                          ) : (
                            <div className='user-profile m-r-8 d-flex' style={{
                              backgroundColor: '#5d883c'
                            }}>
                              <p className='flex-item' style={{
                                color: '#ffffff',
                                fontSize: 14,
                                margin: '0 auto'
                              }}>
                                {`${userData.name}`.trim()[0]}
                              </p>
                            </div>
                          )
                        }
                        <div className="flex-item">
                          <p className="flex-item fs-16 font-weight-600" style={{lineHeight:'16px'}}>{userData.name}</p>
                          <p className="flex-item fs-10 m-t-6" style={{lineHeight:'10px'}}>+91 {userData.phone}</p>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          ) : (
            <div className="w-full" style={{padding:"12px 0px", height:"91%"}}>
              <div className="w-full m-b-12 p-l-12 p-r-12">
                <GymFilter selectedGym={selectedBranch} getSelectedGym={getBranch}/>
              </div>
              
              <div className="d-flex p-l-12 p-r-12 m-t-16 m-b-12">
                <div className="flex-item d-flex w-full" style={{borderBottom:"1px solid var(--darkBlue)"}}>
                  <div onClick={()=>handleBookingType("group-class")} className={`${bookingType == "group-class" && "bg-dark-blue"} apt-type-container d-flex cursor-pointer`}>
                    <p className="flex-item margin-auto" style={{color: bookingType == "group-class" ? "#ffffff" : ""}}>Group Class</p>
                  </div>
                  <div onClick={()=>handleBookingType("appointment")} className={`${bookingType == "appointment" && "bg-dark-blue"} apt-type-container d-flex cursor-pointer`}>
                    <p className="flex-item margin-auto" style={{color: bookingType == "appointment" ? "#ffffff" : ""}}>Appointment</p>
                  </div>
                </div>
              </div>

            
              <div className="w-full p-l-12 p-r-12">
                <SearchFilter count={bookingType == "appointment" ? total.user : "0"} searchingData={handleUserSearchKey} searchType={bookingType == "appointment" ? "User" : "Group Class"} isSearchEnabled={true} isFilterEnabled={false} />
              </div>

              {bookingType == "appointment" ? (
                <div className="w-full m-t-10 p-l-12 p-r-12 apt-user-selection-container" onScroll={handleScroll}>
                  {
                    usersList.map(userData => {
                      return (
                        <div onClick={()=>handleSelectUser(userData)} className="d-flex cursor-pointer apt-user">

                          {
                            userData.profileID ? (
                              <img className='flex-item user-profile m-r-8' src={`${client.config.API_URL}/image/file/${userData.profileID}/auto/auto/70`} />
                            ) : (
                              <div className='user-profile m-r-8 d-flex' style={{
                                backgroundColor: '#5d883c'
                              }}>
                                <p className='flex-item' style={{
                                  color: '#ffffff',
                                  fontSize: 14,
                                  margin: '0 auto'
                                }}>
                                  {`${userData.name}`.trim()[0]}
                                </p>
                              </div>
                            )
                          }
                          <div className="flex-item">
                            <p className="flex-item fs-16 font-weight-600" style={{lineHeight:'16px'}}>{userData.name}</p>
                            <p className="flex-item fs-10 m-t-6" style={{lineHeight:'10px'}}>
                              <span>{getUserRole(userData.role)}</span>
                              {/* {
                                
                                user.designation.map((data, index) => {
                                  return(
                                    <span>{data}{user.designation.length != index + 1 && ", "}</span>
                                  )
                                })
                              } */}
                            </p>
                          </div>
                        </div>
                      )    
                    })
                  }
                  {isUserSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                </div>
              ) : (
                <div className="w-full m-t-16 p-l-12 p-r-12 apt-user-selection-container" onScroll={handleScrollClasses}>
                  <div className="d-flex space-between">
                    <div onClick={toggleInputFields('group-class-name')} className={`${(currentElementId == 'group-class-name' || groupClassName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'group-class-name' || groupClassName) ? "1px solid var(--darkBlue)" : "", width: groupClassName.length > 0 ? "90%" : "100%", transition:"180ms" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'group-class-name' || groupClassName) ? "10px" : "14px", color: (currentElementId == 'group-class-name' || groupClassName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Group Class Name</p>
                      </div>
                      <input onChange={_.debounce(handleGroupClassName,700)} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'group-class-name' || groupClassName) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                    </div>
                    {
                      groupClassName.length > 0 && (
                        <div onClick={()=>handleManageGroupClass()} className="flex-item d-flex bg-red cursor-pointer" style={{width:"40px", height:"40px", borderRadius:"100%", transition:"180ms"}}>
                          <svg className="flex-item m-l-10" width="20" height="20" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.98828 6.5C1.436 6.5 0.988281 6.94772 0.988281 7.5C0.988281 8.05228 1.436 8.5 1.98828 8.5V6.5ZM22.7204 8.20711C23.1109 7.81658 23.1109 7.18342 22.7204 6.79289L16.3564 0.428932C15.9659 0.0384079 15.3327 0.0384079 14.9422 0.428932C14.5517 0.819456 14.5517 1.45262 14.9422 1.84315L20.5991 7.5L14.9422 13.1569C14.5517 13.5474 14.5517 14.1805 14.9422 14.5711C15.3327 14.9616 15.9659 14.9616 16.3564 14.5711L22.7204 8.20711ZM1.98828 7.5V8.5H22.0133V7.5V6.5H1.98828V7.5Z" fill="white"/>
                          </svg>
                        </div>
                      )
                    }
                  </div>
                  <div className="d-flex m-t-24 m-b-16">
                    <div className="d-flex flex-item bg-grey-08 m-r-12" style={{width:"36px", height:"36px", borderRadius:"100%"}}>
                      <p className="flex-item fs-12 font-weight-600 margin-auto">OR</p>
                    </div>
                    <p className="flex-item fs-16 color-dark-blue font-weight-600">Select From existing</p>
                    <svg className="flex-item m-l-12" width="50%" height="2" viewBox="0 0 262 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="2.23637e-05" y1="0.5" x2="262.004" y2="0.511719" stroke="url(#paint0_linear_11201_5940)" stroke-dasharray="2 2"/>
                      <defs>
                      <linearGradient id="paint0_linear_11201_5940" x1="-2.23637e-05" y1="1.5" x2="262.004" y2="1.51172" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#055075"/>
                      <stop offset="1" stop-color="white"/>
                      </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  {
                    groupClasses.map(data => {
                      return(
                        <div onClick={()=>handleManageGroupClass(data)} className="d-flex cursor-pointer apt-user m-b-6" style={{border:"1px solid #e0e0e0", background:"#fafafa"}}>
                          <p className="flex-item color-black fs-15 font-weight-600">{data}</p>
                        </div>
                      )
                    })
                  }
                </div>
              )}
            </div> 
          )
        }

        {
          (selectedUser || manageGroupClass) && (
            <div className="apt-bottom-action-container d-flex w-full space-between">
              <div onClick={handleSelectDate} id="date-select" className="start-date-container flex-item" style={{justifyContent:"center", textAlign:"center"}}>
                <p className="margin-auto fs-12 color-dark-blue">Select start date</p>
                <input className="margin-auto" style={{width:"90%", margin:"0 auto", textAlign:"center"}} type="text" placeholder="DD-MM-YYYY" value={selectedDate?formatDateTime(selectedDate):""} />
              </div>
              
              {
                selectedUser ? (
                  <div onClick={isButtonLock?null:bookingType != "appointment"?SaveGroupClass:SaveAppointmentSlots} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{height:"50px", borderRadius:"25px",pointerEvents:isButtonLock?'none':'auto'}}>
                    <p className='flex-item'>Save & Continue</p>
                  </div>
                ) : (
                  // pointerEvents:isButtonLock?'none':'auto'
                  <div onClick={()=>handleManageGroupClassInstructor()} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{height:"50px", borderRadius:"25px"}}>
                    <p className='flex-item'>Assign to Instructors</p>
                  </div>
                )
              }
              
            </div>
          )
        }
      </div>
    </div>
  )
} 